import React, { useEffect } from "react";
import {
  AdvanceTablesWidget1,
  ListsWidget10,
  ListsWidget11,
  MixedWidget10,
  MixedWidget11,
  MixedWidget12,
  MixedWidget6,
  // TilesWidget1,
  // TilesWidget10,
  // TilesWidget11, TilesWidget12,
  // TilesWidget13, TilesWidget14,
  // TilesWidget3
} from "../../../_metronic/_partials/widgets";
import { Card, CardBody } from "../../../_metronic/_partials/controls";
import { useIntl } from "react-intl";
import { AELink } from "../../../_emywork/components/AELink";
import { StatTilesWidget1 } from "../tiles/StatTilesWidget1";
import { TilesWidget3 } from "../tiles/TilesWidget3";
import { CreateEmyProjectTile } from "../tiles/CreateEmyProjectTile";
import { TilesWidget13 } from "../tiles/TilesWidget13";
import { EmyProjectWidget } from "../tiles/EmyProjectWidget";
import { UsersWidget } from "../tiles/UsersWidget";
import { TilesCreateWidget } from "../tiles/TilesCreateWidget";
import { AERole } from "../../../_emywork/components/AERole";
import { roles } from "../../App";
import { TeamsWidget } from "../tiles/TeamsWidget";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "./_redux/actions";
import { actionTypes } from "./_redux/slice";
import { ContactsWidget } from "../tiles/ContactsWidget";
import { EmyServicesWidget } from "../tiles/EmyServicesWidget";
import { EmyProductWidget } from "../tiles/EmyProductWidget";
import { WalletWidget } from "../tiles/WalletWidget";

export function DashboardPage() {
  const { formatMessage } = useIntl();

  return (
    <>
      {/* <WalletWidget withChart /> */}
      <EmyProjectWidget />
      <div className="row">
        <div className="col-xl-6">
          <div className={"row"}>
            <div className={"col-md-6"}>
              <EmyServicesWidget />
            </div>
            <div className={"col-md-6"}>
              <EmyProductWidget />
            </div>
          </div>
        </div>
        <div className="col-xl-6">
          <TilesCreateWidget className="gutter-b card-stretch" />
        </div>
      </div>

      <div className="row">
        <div className="col-md-6">
          <UsersWidget
            subtitle
            className="gutter-b"
            iconColor="primary"
            widgetHeight="150px"
          />
        </div>
        <div className="col-md-3">
          <TeamsWidget />
        </div>
        <div className="col-md-3">
          <ContactsWidget />
        </div>
      </div>

      {/* end::Row */}

      {/* begin::Row */}
      {/*<div className="row">*/}
      {/*  <div className="col-lg-6 col-xxl-4">*/}
      {/*    <MixedWidget6 className="gutter-b card-stretch" chartColor="danger" />*/}
      {/*  </div>*/}

      {/*  <div className="col-lg-6 col-xxl-8">*/}
      {/*    <AdvanceTablesWidget1 className="card-stretch gutter-b" />*/}
      {/*  </div>*/}
      {/*</div>*/}
      {/* end::Row */}

      {/* begin::Row */}
      {/*<div className="row">*/}
      {/*  <div className="col-xl-4">*/}
      {/*    <MixedWidget10 className="card-stretch gutter-b" />*/}
      {/*  </div>*/}

      {/*  <div className="col-xl-4">*/}
      {/*    <MixedWidget11 className="card-stretch gutter-b" />*/}
      {/*  </div>*/}

      {/*  <div className="col-xl-4">*/}
      {/*    <MixedWidget12 className="card-stretch gutter-b" />*/}
      {/*  </div>*/}
      {/*</div>*/}
      {/* end::Row */}

      {/* begin::Row */}
      {/*<div className="row">*/}
      {/*  <div className="col-lg-6">*/}
      {/*    <ListsWidget10 className="card-stretch gutter-b" />*/}
      {/*  </div>*/}
      {/*  <div className="col-lg-6">*/}
      {/*    <ListsWidget11 className="card-stretch gutter-b" />*/}
      {/*  </div>*/}
      {/*</div>*/}
      {/* end::Row */}

      {/* end::Dashboard */}
    </>
  );
}
